import { yupResolver } from "@hookform/resolvers/yup";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import React, { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import MedicationBasicInformation from "./MedicationBasicInformation";
import MedicationHeader from "./MedicationHeader";
import { LibraryAPI, PrescriptionAPI } from "api";
import { customSettings } from "utils/customConfig";
import { toast } from "react-toastify";

// const schema = yup
//   .array()
//   .of(
//     yup.object({
//       medicationName: yup.string().required("Medication name is required"),
//       dosage: yup.string().required("Dosage is required"),
//       frequency: yup.string().required("Frequency is required"),
//       duration: yup.string().required("Duration is required"),
//       instructions: yup.string().required("Instructions are required"),
//     })
//   )
//   .required();

const schema = yup.object({
  prescriptions: yup
    .array()
    .of(
      yup.object({
        medicationName: yup.string().required("Medication name is required"),
        dosage: yup.string().required("Dosage is required"),
        frequency: yup.string().required("Frequency is required"),
        duration: yup.string().required("Duration is required"),
        instructions: yup.string().required("Instructions are required"),
      })
    )
    .required("Prescriptions are required"),
});

const AddMedication = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      prescriptions: [{}],
    },
  });
  const { handleSubmit, reset, setValue } = methods;

  console.log("location?.state", location?.state);

  const onSubmit = async (data) => {
    let patientId =
      location.state && !location.state.parentId1
        ? location.state?.patientId
        : location.state?.parentId1;

    let myData = {
      ...data,
      prescriptions: (data.prescriptions || []).map((item) => ({
        ...item,
        patientId: patientId,
        id: location?.state.id ?? 0,
      })),
    };

    console.log(myData.prescriptions);

    // {
    //   myData.id = location?.state ? location?.state?.id : 0;
    //   myData.library = 4;
    //   myData.parentId1 =
    //     location.state && !location.state.parentId1
    //       ? location.state.patientId
    //       : location.state?.parentId1;
    //   myData.parentId2 = data?.rx;
    //   myData.phone = "";
    //   myData.email = "";
    //   myData.logo = "";
    //   myData.level = "";
    //   myData.strength = "";
    // }

    if (!location.state) {
      toast.error("Please add Patient first", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      return;
    }

    // console.log(myData);

    try {
      await PrescriptionAPI.post(myData.prescriptions);
      toast.success("Record updated successfully", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      reset({
        prescriptions: [
          {
            medicationName: location.state.medicationName || "",
            dosage: location.state.dosage || "",
            frequency: location.state.frequency || "",
            duration: location.state.duration || "",
            instructions: location.state.instructions || "",
          },
        ],
      });
    }
  }, []);

  return (
    <>
      <div className="py-2">
        <BreadCrumb />
      </div>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">
            <Col xs={12}>
              <MedicationHeader />
            </Col>
            <Col lg={12}>
              <MedicationBasicInformation />
              {/* <ProductUpload /> */}
              {/* <ProductDetails /> */}
              {/* <ProductSpecifications /> */}
            </Col>
            {/* <Col xs={12}>
              <CategoryFooter />
            </Col> */}
          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddMedication;
